export default "__VITE_ASSET__CZyCqtxn__"